export default{
    interfaceUrl:'/symphony-design/execute',
    
}


// WEBPACK FOOTER //
// ./src/utils/config.js